var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('i',{class:_vm.icon}),_c('span',[_vm._v(" "+_vm._s(_vm.formparamStr || _vm.dataTreeObj.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }